// extracted by mini-css-extract-plugin
module.exports = {"container":"CreateBoard_container__yjJjj","header":"CreateBoard_header__3w_4W","section":"CreateBoard_section__2VRCP","controls":"CreateBoard_controls__1SwsX"};